import { Inject, Injectable, Injector } from '@angular/core';
import { UtilsBaseApiService } from '@brunsker/libs/core/utils/base-api';
import { ENVIRONMENT_TOKEN, Environment } from '@brunsker/libs/core/utils/http-log-interceptor/src';
import { RegiaoResponse } from '../../../models/region.models';

@Injectable({
  providedIn: 'root',
})
export class NewApiRegiaoService extends UtilsBaseApiService<NewApiRegiaoService> {
  constructor(
    @Inject(ENVIRONMENT_TOKEN) readonly environment: Environment,
    override readonly injector: Injector
  ) {
    super('regiao', injector, environment.BASE_API_URL);
  }

  getRegioes() {
    return this.httpClient.get<RegiaoResponse[]>(
      `${this.BASE_URL}home/regiao/1`
    );
  }
}
